export class BigQueryNativePitrDestination {
    'datasetId';
    'location';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "datasetId",
            "baseName": "datasetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BigQueryNativePitrDestination.attributeTypeMap;
    }
    constructor() {
    }
}
